import { YA_ID } from 'reactApp/appHelpers/configHelpers';

export const sendYaMetrika = (label: string) => {
    window[`yaCounter${YA_ID}`]?.reachGoal(label);
};
